import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Cover } from 'types/cover';
import { coverExists, isNoDuplicate, removeCoverByPosition } from 'utils';

export interface ReviewAndPay {
  additionalCovers: Cover[];
}

const initialState: ReviewAndPay = {
  additionalCovers: [],
};

export const reviewAndPaySlice = createSlice({
  name: 'reviewAndPay',
  initialState,
  reducers: {
    addAdditionalCovers: (state, action: PayloadAction<Cover>) => {
      if (isNoDuplicate(state.additionalCovers, action.payload)) {
        state.additionalCovers = [...state.additionalCovers, action.payload];
      }
    },
    removeAdditionalCovers: (state, action: PayloadAction<Cover>) => {
      coverExists(state.additionalCovers, action.payload) &&
        removeCoverByPosition(state.additionalCovers, action.payload);
    },
    resetAdditionalCovers: (state) => {
      state.additionalCovers = [];
    },
  },
});

export const { addAdditionalCovers, resetAdditionalCovers, removeAdditionalCovers } =
  reviewAndPaySlice.actions;

export default reviewAndPaySlice.reducer;
